/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const guidebookDivorceSectionStyle = {
  box: {
    padding: "10px 20px",
  },
  boxHeading: {
    color: "primary.main",
    fontWeight: 500,
  },
  header: {
    marginBottom: "30px",
    textAlign: "center",
  },
  centered: {
    textAlign: "center",
  },
  buttonContainer: {
    textAlign: "center",
  },
  infoButton: {
    margin: "0 auto",
  },
};

export default guidebookDivorceSectionStyle;
